import styled from "styled-components"

import Flex from "@irati/ui/src/Flex"

export const Step = styled(Flex)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  p {
    margin-top: ${({theme}) => theme.spacing.oneAndHalf};
    margin-left: ${({theme}) => theme.spacing.half};
  }
  span:last-child {
    margin-top: ${({theme}) => theme.spacing.half};
  }
`
